/** @format */

export const ScreenWidth = () => {
	if (window.screen.width > 768) {
		return false
	} else {
		return true
	}
}
